import './App.css';
import ContactForm from './components/ContactForm';
import TopComp from './components/TopComp';
import BlockFirst from './components/BlockFirst';
import BlockTwo from './components/BlockTwo';
import BlockThree from './components/BlockThree';
import BlockFour from './components/BlockFour';
import WebPages from './components/WebPages';
import BlockFifth from './components/BlockFifth';
import About from './components/About';
import BottomComp from './components/BottomComp';
import DesignPages from './components/DesignPages';
import {Navbar, Nav} from 'react-bootstrap';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

function App() {
  return (
    <div className="container-fluid">
      
      <Router>
            <div class="row pirmasblokas1 justify-content-end "  >
            <Navbar  className=" navbar-dark"  >
           
            <Nav className="mr-auto flex-column flex-sm-row" >
            <Nav.Item  className="px-3 text-white" style={{ fontWeight: 600 }}>
            <Nav.Link ><Link className="text-light" to="/">SVEIKI!</Link></Nav.Link>
            </Nav.Item>
            <Nav.Item className="px-3 " style={{ fontWeight: 600 }}>
            <Nav.Link ><Link className="text-light" to="/maketavimas">TINKLAPIAI</Link></Nav.Link>
            </Nav.Item>
            <Nav.Item className="px-3 " style={{ fontWeight: 600 }}>
            <Nav.Link ><Link className="text-light" to="/maketavimas1">GRAFIKA</Link></Nav.Link>
            </Nav.Item>
            <Nav.Item className="px-3 " style={{ fontWeight: 600 }}>
            <Nav.Link ><Link className="text-light" to="/susipazinkim">SUSIPAŽINKIM</Link></Nav.Link>
            </Nav.Item>
            </Nav>
            </Navbar>
            </div> 
            <Switch>
                <Route path="/maketavimas">
                  <TopComp/>
                  <WebPages/>
                  <BottomComp/>
                </Route>
                <Route path="/maketavimas1">
                  <TopComp/>
                  <DesignPages/>
                  <BottomComp/>
                </Route>
                <Route path="/susipazinkim">
                  <TopComp/>
                  <About/> 
                  <ContactForm />
                  <BottomComp/>
                </Route>
                <Route path="/">
                  <TopComp/>
                  <BlockFirst/>
                  <BlockTwo/>
                  <BlockThree/>
                  <BlockFifth/> 
                  <BlockFour/>
                  <ContactForm />
                  <BottomComp/>
                </Route>
            </Switch>
        </Router>
    </div>
  );
}

export default App;
